import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=5e66e807&setup=true&lang=css"

const __exports__ = script;

export default __exports__